import { render, staticRenderFns } from "./SummarySlide.vue?vue&type=template&id=1f995a13&scoped=true&"
import script from "./SummarySlide.vue?vue&type=script&lang=js&"
export * from "./SummarySlide.vue?vue&type=script&lang=js&"
import style0 from "./SummarySlide.vue?vue&type=style&index=0&id=1f995a13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f995a13",
  null
  
)

export default component.exports